// ============================================
// tracking.js — helpers de rastreo de envíos (carrier-agnóstico)
// Physiology New Look · Medusa v2
//
// Medusa expone el tracking de un envío en el fulfillment. Según cómo se haya
// capturado la guía, el dato puede venir en distintas formas:
//   - fulfillment.labels[0]            → { tracking_number, url, label_url }
//   - fulfillment.tracking_links[0]    → { tracking_number, url }
//   - fulfillment.tracking_numbers[0]  → string
// Normalizamos todo a { carrier, number, url }.
// ============================================

// URL pública de rastreo de DHL México. NO requiere API key — solo el número
// de guía. Se usa cuando el envío es DHL pero no traemos una URL explícita.
export function buildDhlTrackingUrl(trackingNumber) {
  if (!trackingNumber) return null;
  return `https://www.dhl.com/mx-es/home/rastreo.html?tracking-id=${encodeURIComponent(
    trackingNumber
  )}`;
}

// Intenta deducir el carrier a partir del shipping option o del nombre del
// proveedor de fulfillment. Devuelve una etiqueta legible ("DHL", "Estafeta"…)
// o null si no se reconoce.
function carrierFromFulfillment(fulfillment) {
  const haystack = [
    fulfillment?.shipping_option?.name,
    fulfillment?.provider_id,
    fulfillment?.shipping_option?.provider_id,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
  if (!haystack) return null;
  if (haystack.includes('dhl')) return 'DHL';
  if (haystack.includes('estafeta')) return 'Estafeta';
  if (haystack.includes('fedex')) return 'FedEx';
  if (haystack.includes('skydropx')) return 'Skydropx';
  return null;
}

// Extrae { carrier, number, url } del primer fulfillment con guía de la orden.
// Si es DHL y no hay URL explícita pero sí número, construye la URL pública DHL.
export function getTracking(order) {
  const fulfillment = order?.fulfillments?.[0];
  if (!fulfillment) return null;

  const label = fulfillment.labels?.[0];
  const link = fulfillment.tracking_links?.[0];

  const number =
    label?.tracking_number ||
    link?.tracking_number ||
    fulfillment.tracking_numbers?.[0] ||
    null;

  let url = label?.url || link?.url || null;

  if (!number && !url) return null;

  const carrier = carrierFromFulfillment(fulfillment);

  // Fallback: DHL sin URL → armamos la pública a partir del número.
  if (!url && number && carrier === 'DHL') {
    url = buildDhlTrackingUrl(number);
  }

  return { carrier, number, url };
}
